export const groupArrayByPropertyName = function (xs, key) {
    return xs.reduce(function (rv, x) {
        (rv[x[key]] ??= []).push(x);
        return rv;
    }, {});
};